/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './home/home.component.ngfactory';
import * as i4 from './submission-details/submission-details.component.ngfactory';
import * as i5 from './donation/donation.component.ngfactory';
import * as i6 from './app.component.ngfactory';
import * as i7 from '@angular/common';
import * as i8 from '@angular/platform-browser';
import * as i9 from '@angular/animations/browser';
import * as i10 from '@angular/platform-browser/animations';
import * as i11 from '@angular/router';
import * as i12 from 'angulartics2/dist/core/angulartics2';
import * as i13 from 'angulartics2/dist/providers/ga/angulartics2-ga';
import * as i14 from '@angular/common/http';
import * as i15 from '@angular/forms';
import * as i16 from '@angular/animations';
import * as i17 from 'ngx-window-token/dist/src/ngx-window-token';
import * as i18 from 'ngx-clipboard/src/clipboard.service';
import * as i19 from '../../app/submission.service';
import * as i20 from '../../app/metadata.service';
import * as i21 from '../../app/home/home.component';
import * as i22 from '../../app/submission-details/submission-details.component';
import * as i23 from '../../app/donation/donation.component';
import * as i24 from 'angulartics2/dist/index';
import * as i25 from '../../app/core/app-routing.module';
import * as i26 from 'angular2-materialize/dist/materialize-module';
import * as i27 from 'ng2-charts/charts/charts';
import * as i28 from 'ngx-clipboard/src/index';
import * as i29 from 'ng2-adsense';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.HomeComponentNgFactory,i4.SubmissionDetailsComponentNgFactory,i5.DonationComponentNgFactory,
              i6.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i7.NgLocalization,
              i7.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,
              ([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,([] as any[])),
          i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),i0.ɵmpd(4608,i8.DomSanitizer,
              i8.ɵe,[i7.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i8.DomSanitizer]),
          i0.ɵmpd(4608,i8.HAMMER_GESTURE_CONFIG,i8.HammerGestureConfig,([] as any[])),
          i0.ɵmpd(5120,i8.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i8.ɵDomEventsPlugin(p0_0),new i8.ɵKeyEventsPlugin(p1_0),new i8.ɵHammerGesturesPlugin(p2_0,
                p2_1)];
          },[i7.DOCUMENT,i7.DOCUMENT,i7.DOCUMENT,i8.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i8.EventManager,i8.EventManager,[i8.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i8.ɵDomSharedStylesHost,i8.ɵDomSharedStylesHost,[i7.DOCUMENT]),
          i0.ɵmpd(4608,i8.ɵDomRendererFactory2,i8.ɵDomRendererFactory2,[i8.EventManager,
              i8.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i9.AnimationDriver,i10.ɵc,([] as any[])),
          i0.ɵmpd(5120,i9.ɵAnimationStyleNormalizer,i10.ɵd,([] as any[])),i0.ɵmpd(4608,
              i9.ɵAnimationEngine,i10.ɵb,[i9.AnimationDriver,i9.ɵAnimationStyleNormalizer]),
          i0.ɵmpd(5120,i0.RendererFactory2,i10.ɵe,[i8.ɵDomRendererFactory2,i9.ɵAnimationEngine,
              i0.NgZone]),i0.ɵmpd(6144,i8.ɵSharedStylesHost,(null as any),[i8.ɵDomSharedStylesHost]),
          i0.ɵmpd(4608,i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i8.Meta,
              i8.Meta,[i7.DOCUMENT]),i0.ɵmpd(4608,i8.Title,i8.Title,[i7.DOCUMENT]),
          i0.ɵmpd(5120,i11.ActivatedRoute,i11.ɵf,[i11.Router]),i0.ɵmpd(4608,i11.NoPreloading,
              i11.NoPreloading,([] as any[])),i0.ɵmpd(6144,i11.PreloadingStrategy,
              (null as any),[i11.NoPreloading]),i0.ɵmpd(135680,i11.RouterPreloader,
              i11.RouterPreloader,[i11.Router,i0.NgModuleFactoryLoader,i0.Compiler,
                  i0.Injector,i11.PreloadingStrategy]),i0.ɵmpd(4608,i11.PreloadAllModules,
              i11.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i11.ROUTER_INITIALIZER,
              i11.ɵi,[i11.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i11.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i12.Angulartics2,i12.Angulartics2,
              [i7.Location,i11.Router]),i0.ɵmpd(4608,i13.Angulartics2GoogleAnalytics,
              i13.Angulartics2GoogleAnalytics,[i12.Angulartics2]),i0.ɵmpd(4608,i14.HttpXsrfTokenExtractor,
              i14.ɵg,[i7.DOCUMENT,i0.PLATFORM_ID,i14.ɵe]),i0.ɵmpd(4608,i14.ɵh,i14.ɵh,
              [i14.HttpXsrfTokenExtractor,i14.ɵf]),i0.ɵmpd(5120,i14.HTTP_INTERCEPTORS,
              (p0_0:any) => {
                return [p0_0];
              },[i14.ɵh]),i0.ɵmpd(4608,i14.ɵd,i14.ɵd,([] as any[])),i0.ɵmpd(6144,i14.XhrFactory,
              (null as any),[i14.ɵd]),i0.ɵmpd(4608,i14.HttpXhrBackend,i14.HttpXhrBackend,
              [i14.XhrFactory]),i0.ɵmpd(6144,i14.HttpBackend,(null as any),[i14.HttpXhrBackend]),
          i0.ɵmpd(5120,i14.HttpHandler,i14.ɵinterceptingHandler,[i14.HttpBackend,[2,
              i14.HTTP_INTERCEPTORS]]),i0.ɵmpd(4608,i14.HttpClient,i14.HttpClient,
              [i14.HttpHandler]),i0.ɵmpd(4608,i15.ɵi,i15.ɵi,([] as any[])),i0.ɵmpd(4608,
              i15.FormBuilder,i15.FormBuilder,([] as any[])),i0.ɵmpd(4608,i16.AnimationBuilder,
              i10.ɵBrowserAnimationBuilder,[i0.RendererFactory2,i8.DOCUMENT]),i0.ɵmpd(5120,
              i17.WINDOW,i17._window,([] as any[])),i0.ɵmpd(5120,i18.ClipboardService,
              i18.CLIPBOARD_SERVICE_PROVIDER_FACTORY,[i8.DOCUMENT,i17.WINDOW,[3,i18.ClipboardService]]),
          i0.ɵmpd(4608,i19.SubmissionService,i19.SubmissionService,[i14.HttpClient]),
          i0.ɵmpd(4608,i20.MetadataService,i20.MetadataService,[i14.HttpClient]),i0.ɵmpd(512,
              i7.CommonModule,i7.CommonModule,([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,
              i8.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i11.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i11.ɵg,i11.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i8.ɵc(p0_0,p0_1),i11.ɵh(p1_0)];
              },[[2,i8.NgProbeToken],[2,i0.NgProbeToken],i11.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i8.BrowserModule,i8.BrowserModule,[[3,i8.BrowserModule]]),i0.ɵmpd(1024,
              i11.ɵa,i11.ɵd,[[3,i11.Router]]),i0.ɵmpd(512,i11.UrlSerializer,i11.DefaultUrlSerializer,
              ([] as any[])),i0.ɵmpd(512,i11.ChildrenOutletContexts,i11.ChildrenOutletContexts,
              ([] as any[])),i0.ɵmpd(256,i11.ROUTER_CONFIGURATION,{},([] as any[])),
          i0.ɵmpd(1024,i7.LocationStrategy,i11.ɵc,[i7.PlatformLocation,[2,i7.APP_BASE_HREF],
              i11.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i7.Location,i7.Location,[i7.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i11.ROUTES,() => {
            return [[{path:'',component:i21.HomeComponent},{path:'s/:id',component:i22.SubmissionDetailsComponent},
                {path:'donate',component:i23.DonationComponent}]];
          },([] as any[])),i0.ɵmpd(1024,i11.Router,i11.ɵe,[i0.ApplicationRef,i11.UrlSerializer,
              i11.ChildrenOutletContexts,i7.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i11.ROUTES,i11.ROUTER_CONFIGURATION,[2,i11.UrlHandlingStrategy],
              [2,i11.RouteReuseStrategy]]),i0.ɵmpd(512,i11.RouterModule,i11.RouterModule,
              [[2,i11.ɵa],[2,i11.Router]]),i0.ɵmpd(1024,i24.ANGULARTICS2_FORROOT_GUARD,
              i24.provideForRootGuard,[[3,i12.Angulartics2]]),i0.ɵmpd(512,i24.Angulartics2Module,
              i24.Angulartics2Module,[[2,i24.ANGULARTICS2_FORROOT_GUARD]]),i0.ɵmpd(512,
              i25.AppRoutingModule,i25.AppRoutingModule,([] as any[])),i0.ɵmpd(512,
              i14.HttpClientXsrfModule,i14.HttpClientXsrfModule,([] as any[])),i0.ɵmpd(512,
              i14.HttpClientModule,i14.HttpClientModule,([] as any[])),i0.ɵmpd(512,
              i15.ɵba,i15.ɵba,([] as any[])),i0.ɵmpd(512,i15.FormsModule,i15.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i15.ReactiveFormsModule,i15.ReactiveFormsModule,
              ([] as any[])),i0.ɵmpd(512,i26.MaterializeModule,i26.MaterializeModule,
              ([] as any[])),i0.ɵmpd(512,i27.ChartsModule,i27.ChartsModule,([] as any[])),
          i0.ɵmpd(512,i10.BrowserAnimationsModule,i10.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i17.WindowTokenModule,i17.WindowTokenModule,([] as any[])),i0.ɵmpd(512,
              i28.ClipboardModule,i28.ClipboardModule,([] as any[])),i0.ɵmpd(512,i29.AdsenseModule,
              i29.AdsenseModule,([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,
              ([] as any[])),i0.ɵmpd(256,i14.ɵe,'XSRF-TOKEN',([] as any[])),i0.ɵmpd(256,
              i14.ɵf,'X-XSRF-TOKEN',([] as any[])),i0.ɵmpd(256,i29.ADSENSE_CONFIG,
              {adClient:'ca-pub-4726807445608817',adSlot:1046247731,layout:'in-article',
                  adFormat:'\'fluid\'',display:'\'block\''},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM5NDYzMjk0NzAvc3JjL2Zyb250ZW5kL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/app/app.module.ngfactory.ts